<template>
  <div class="product-inform">
    <div class="card">
      <b-row class="my-3 mx-1 align-items-center">
        <b-col cols="4">
          <h6 class="mb-0">
            <span v-text="title" class="mr-1" /><span
              v-text="`(${voucherList.length})`"
            />
          </h6>
        </b-col>
        <b-col cols="8" class="text-right pr-2">
          <b-button
            v-for="(btn, idx) in filterButtons"
            :key="idx"
            :pressed.sync="btn.state"
            variant="info"
            class="alternative ml-2"
            @click="checkFilterBtns(btn)"
          >
            <span v-if="btn.state"  />
            <span v-text="btn.caption" />
          </b-button>
        </b-col>
      </b-row>
      <div class="activites-bar row py-2 px-3">
        <b-col cols="6">Name &amp; Description</b-col>
        <b-col cols="2"># Available</b-col>
        <b-col cols="2">Gift Value</b-col>
        <b-col cols="2">&nbsp;</b-col>
      </div>
      <div class="gvoucher-container" v-if="voucherList.length != 0">
        <b-row
          class="py-3 px-3 align-items-center gvoucher-list"
          v-for="item in voucherList"
          :key="item.id"
        >
          <b-col cols="6"
            ><p class="mb-0" v-text="_.upperFirst(item.gv_group_name)"/>
            <span
              class="grey-60"
              v-text="_.upperFirst(item.gv_group_description)"
          /></b-col>
          <b-col cols="2" v-text="item.available_voucher" />
          <b-col cols="2" v-text="giftValueText(item)" />
          <b-col cols="2"
            ><b-button variant="outline-primary" @click="getGroupData(item)"
              >+ Add</b-button
            ></b-col
          ></b-row
        >
      </div>
      <div
        class="gvoucher-container d-flex align-items-center justify-content-center"
        v-else
      >
        <!-- <div class="d-flex align-items-center"> -->
        <p class="text-muted">No voucher group found</p>
        <!-- </div> -->
      </div>
    </div>
    <!-- Voucher detail popup-->
    <b-modal
      id="voucher-detail"
      ref="voucher-detail"
      centered
      hide-footer
      hide-header
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row>
        <b-col md="11">
          <h6 v-text="_.upperFirst(voucherDetails.groupInfo.gv_group_name)" />
          <p
            class="mb-3"
            v-text="_.upperFirst(voucherDetails.groupInfo.gv_group_description)"
          />
        </b-col>
        <b-col md="1" class="text-center">
          <font-awesome-icon
            class="cursor-p"
            @click="$refs['voucher-detail'].hide()"
            :icon="['fas', 'times']"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          <span class="grey-60">Type</span>
          <p class="mt-1" v-text="voucherDetails.groupInfo.gv_type" />
        </b-col>
        <b-col cols="4">
          <span class="grey-60">Category</span>
          <p
            class="mt-1"
            v-text="_.upperFirst(voucherDetails.groupInfo.gv_cat_name)"
          />
        </b-col>
        <b-col cols="4">
          <span class="grey-60">Packs</span>
          <p
            class="mt-1"
            v-text="
              voucherDetails.groupInfo.is_with_pack == '0'
                ? 'No Packs'
                : 'With Packs'
            "
          />
        </b-col>
        <b-col cols="4">
          <span class="grey-60">Valid Upto</span>
          <p class="mt-1" v-text="voucherDetails.groupInfo.validity" />
        </b-col>
        <b-col cols="4">
          <span class="grey-60">Gift Value</span>
          <p class="mt-1" v-text="voucherDetails.groupInfo.value_type" />
        </b-col>
        <b-col cols="4">
          <span class="grey-60">Sale Value</span>
          <p class="mt-1" v-text="saleValueText" />
        </b-col>
      </b-row>
      <div class="clearfix mb-4"><hr /></div>

      <b-row>
        <b-col
          cols="4"
          class="mb-3"
          v-for="(item, index) in voucherDetails.presetDetails"
          :key="index"
        >
          <p
            :class="{
              'mb-0': true,
              'text-primary': item.config_value == 'Yes',
              'text-danger': item.config_value == 'No',
            }"
          >
            <font-awesome-icon
              :icon="['fas', item.config_value == 'Yes' ? 'check' : 'minus']"
              class="mr-2"
            />
            <span v-text="item.config_name" />
          </p>
          <span
            class="grey-60 ml-4"
            v-if="item.hasOwnProperty('limit') && item.limit != 0"
            v-text="
              `${_.upperFirst(item.limit_text)} ${currencySymbol + item.limit}`
            "
          />
        </b-col>
      </b-row>
      <div class="text-right mt-4">
        <b-button
          class="mr-2"
          id="remove-selected"
          :disabled="$loading || isGroupPresentInCart"
          @click="updateCart('remove_group')"
        >
          <b-spinner small v-if="$loading"></b-spinner>
          <span v-if="!$loading">Remove all from Cart</span>
        </b-button>
        <b-button
          variant="primary"
          id="confirm-selected"
          :disabled="$loading"
          @click="selectQuantity"
        >
          <b-spinner small v-if="$loading" />
          <span v-if="!$loading">Select Quantity</span>
        </b-button>
      </div>
    </b-modal>
    <!-- Voucher Qty, popup-->
    <b-modal
      id="voucher-qty"
      ref="voucher-qty"
      centered
      hide-footer
      :title="_.upperFirst(voucherDetails.groupInfo.gv_group_name)"
      size="sm"
      no-close-on-backdrop
      no-close-on-esc
    >
      <label>Enter Gift Value</label>
      <b-form-input
        type="number"
        class="mb-2"
        autocomplete="off"
        :disabled="voucherDetails.groupInfo.value_type == 'Fixed'"
        v-model="voucherDetails.groupInfo.gift_value"
        placeholder="0.00"
        @input="getSaleValue"
        v-negative-disable
      />
      <label>Sale Value</label>
      <b-form-input
        type="number"
        class="mb-2"
        autocomplete="off"
        disabled
        v-model="voucherDetails.groupInfo.sale_value"
        placeholder="Enter Gift Value to preview"
      />
      <label>Enter quantity to add</label>
      <b-form-input
        type="number"
        class="mb-3"
        v-model="bulkQty"
        autocomplete="off"
        placeholder="Enter quantity"
      />
      <p class="grey-10 sequence-code fs-12">
        Sequence code(s) to be added:<br />
        <span v-for="(item, index) in rangeData" :key="index">
          {{ `${item.s}-${item.e} | Total - ${item.t}` }} <br
        /></span>
      </p>
      <div class="d-flex mt-4">
        <b-button
          class="mr-1"
          id="view-voucher"
          variant="outline-primary"
          block
          @click="getVoucherList(1, 'popup')"
          :disabled="$loading"
          >View Voucher</b-button
        >
        <b-button
          class="nl-1"
          variant="primary"
          block
          id="update-cart"
          :disabled="$loading || checkBulkUpdateBtn"
          @click="addBulkQty"
          v-shortkey.once="['enter']"
          @shortkey="addBulkQty"
        >
          <b-spinner small v-if="$loading" />
          <span v-if="!$loading">Update Cart</span>
        </b-button>
      </div>
    </b-modal>

    <!-- Voucher group bulk popup-->
    <b-modal
      id="voucher-bulk"
      ref="voucher-bulk"
      centered
      hide-footer
      :title="_.upperFirst(voucherDetails.groupInfo.gv_group_name)"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      @hide="clearGvList"
    >
      <b-row class="activites-bar py-2 negative-margin">
        <b-col cols="1" class="text-center">
          <div class="custom-check">
            <input
              type="checkbox"
              value=""
              id="select-group"
              @click="selectAllVoucher"
            />
            <label class="mb-0 pl-0" for="select-group"></label>
          </div>
        </b-col>
        <b-col cols="1" class="text-center">#</b-col>
        <b-col cols="2">Pack/Sequence</b-col>
        <b-col cols="4">Voucher Code</b-col>
        <b-col cols="2">Sale Value</b-col>
        <b-col cols="2">Gift Value</b-col>
      </b-row>
      <b-row
        class="py-3 voucher-list align-items-center negative-margin"
        v-for="(item, index) in voucherBulkList"
        :key="index"
      >
        <b-col cols="1" class="text-center">
          <div :class="{ 'custom-check': true }">
            <input
              type="checkbox"
              :value="item.voucher_sequence"
              :id="`gv-${item.voucher_sequence}`"
              :checked="
                typeof item.is_received_boolean != 'boolean'
                  ? false
                  : item.is_received_boolean
              "
              @click="selectVoucher(index, item)"
            />
            <label
              class="mb-0 pl-0"
              :for="`gv-${item.voucher_sequence}`"
            ></label>
          </div>
        </b-col>
        <b-col cols="1" class="text-center" v-text="index + 1" />
        <b-col cols="2" v-text="item.voucher_sequence" />
        <b-col cols="4" v-text="helper.hideMiddleText(item.gv_code)" />
        <b-col cols="2" v-html="saleDisp(item)" />
        <b-col cols="2">
          <b-input
            placeholder="0.00"
            v-model="item.gift_value"
            type="number"
            v-negative-disable
            @input="updateGiftValue(item)"
            v-if="item.value_type == 'Custom' && item.is_received_boolean"
          />
          <span v-else v-html="giftDisp(item)" />
        </b-col>
      </b-row>
      <b-row class="mt-5 align-items-center">
        <b-col cols="4">
          <b-pagination
            class="mb-0"
            v-model="pagination.page"
            pills
            :total-rows="pagination.total_records"
            :per-page="pagination.perPageLimit"
            align="left"
            @change="getVoucherList"
          />
        </b-col>
        <b-col cols="8" class="text-right">
          <b-button
            id="remove-cart"
            variant="outline-danger"
            :disabled="$loading"
            v-if="false"
            >Remove from Cart</b-button
          >
          <b-button
            class="ml-2"
            id="edit-bulk"
            variant="outline-primary"
            @click="$refs['voucher-bulk'].hide(), $refs['voucher-qty'].show()"
            :disabled="$loading"
            >Edit Bulk Quantity</b-button
          >
          <b-button
            class="ml-2"
            variant="primary"
            id="update-cart"
            @click="updateCart('add_update')"
            :disabled="$loading || disableUpdateBtn"
          >
            <span v-if="!$loading" v-text="updateBtnText" />
            <b-spinner small v-if="$loading" />
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import db from "../database";
import * as helper from "../helper";
import * as msg from "../message";

export default {
  name: "voucher-group",
  components: {},
  data() {
    return {
      title: "All Groups",
      isShow: false,
      toggle: false,
      filterButtons: [
        { caption: "Fixed", key: "Fixed", state: false },
        { caption: "Custom", key: "Custom", state: false },
        {
          caption: "Physical",
          key: "Physical-Voucher",
          state: false,
        },
        {
          caption: "E-Vouchers",
          key: "E-Voucher",
          state: false,
        },
      ],
      voucherBulkList: [],
      voucherDetails: {
        groupInfo: {},
        presetDetails: [],
      },
      pagination: {
        page: 1,
        perPageLimit: 8,
        total_records: 0,
      },
      updateBtnText: "Update Cart",
      bulkQty: "",
      disableUpdateBtn: true,
      rangeData: [],
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    _() {
      return _;
    },
    helper() {
      return helper;
    },
    voucherList() {
      return this.state.giftVoucher.groups.group_list;
    },
    isGroupPresentInCart() {
      let notPresent = true;
      let temp = _.find(
        this.state.giftVoucher.cart.group_cart_details,
        (item) => {
          return item.gv_group_id == this.voucherDetails.groupInfo.gv_group_id;
        }
      );
      if (temp != undefined) notPresent = false;
      return notPresent;
    },
    checkBulkUpdateBtn() {
      let temp = true;
      if (
        this.bulkQty != "" &&
        this.bulkQty != "0" &&
        this.voucherDetails.groupInfo.gift_value != null &&
        this.voucherDetails.groupInfo.gift_value != "" &&
        parseInt(this.voucherDetails.groupInfo.gift_value) != 0
      )
        temp = false;
      return temp;
    },
    saleValueText() {
      return this.voucherDetails.groupInfo.value_type == "Custom"
        ? "Custom"
        : `${this.currencySymbol}${this.voucherDetails.groupInfo.sale_value}`;
    },
  },
  created() {
    this.getVoucherGroup();
  },
  mounted() {
    this.clearGvList();
  },
  beforeDestroy() {
    db.gvList.clear();
  },
  methods: {
    selectQuantity() {
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/getRange", {
          gv_group_id: this.voucherDetails.groupInfo.gv_group_id,
        })
        .then((res) => {
          this.rangeData = res.data.data;
          this.$loading = false;
          if (res.data.status != "fail") {
            this.$refs["voucher-detail"].hide();
            this.$refs["voucher-qty"].show();
            this.bulkQty = "";
            if (this.voucherDetails.groupInfo.value_type == "Custom") {
              this.voucherDetails.groupInfo.gift_value = null;
              this.voucherDetails.groupInfo.sale_value = null;
            }
          }
        })
        .catch(() => (this.$loading = false));
    },
    getVoucherGroup() {
      let temp = [];
      _.filter(this.filterButtons, (b) => {
        if (b.state) temp.push(b.key);
      });

      this.$store
        .dispatch("giftVoucher/getVoucherGroup", JSON.stringify(temp))
        .then(() => (this.$loading = false))
        .catch(() => (this.$loading = false));
    },
    checkFilterBtns(btn) {
      this.$loading = true;
      let val = "";
      if (btn.caption == "Fixed") val = "Custom";
      else if (btn.caption == "Custom") val = "Fixed";
      else if (btn.caption == "Physical") val = "E-Vouchers";
      else if (btn.caption == "E-Vouchers") val = "Physical";

      let temp = _.find(this.filterButtons, (b) => {
        return b.caption == val;
      });
      temp.state = false;

      this.getVoucherGroup();
    },
    getGroupData(group) {
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/getVoucherGroupData", group.gv_group_id)
        .then((res) => {
          this.voucherDetails = {
            presetDetails: res.data.data.presetDetails,
            groupInfo: res.data.data.groupInfo,
          };
          this.$store.dispatch("giftVoucher/mapVoucherToDatabase");
          this.$refs["voucher-detail"].show();
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    getVoucherList(page, where) {
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/getVoucherList", {
          gv_group_id: this.voucherDetails.groupInfo.gv_group_id,
          page: page,
          per_page: this.pagination.perPageLimit,
        })
        .then(async (res) => {
          this.voucherBulkList = res.data.data.voucherList.data;
          if (document.getElementById("select-group") != null)
            document.getElementById("select-group").checked = false;
          await this.voucherBulkList.forEach(async (item) => {
            await db.gvList.get({ gv_id: item.gv_id }, (voucher) => {
              if (voucher != undefined) {
                item.is_received_boolean = voucher.is_received_boolean;
                item.sale_value = voucher.sale_value;
                item.gift_value = voucher.gift_value;
              } else {
                if (item.value_type == "Custom") item.gift_value = null;
                item.is_received_boolean = JSON.parse(
                  item.is_received_boolean.toLowerCase()
                );
                if (item.is_received_boolean) this.addToDatabase(item);
              }
            });
          });
          if (where == "popup") {
            this.$refs["voucher-qty"].hide();
            this.$refs["voucher-bulk"].show();
          }
          this.pagination.total_records = res.data.data.voucherList.total;
          this.$loading = false;
          this.voucherGroupSelect();
        })
        .catch(() => (this.$loading = false));
    },
    selectVoucher(index, item) {
      if (item.value_type == "Custom") {
        item.sale_value = null;
        item.gift_value = null;
      }
      this.voucherBulkList[index].is_received_boolean =
        typeof this.voucherBulkList[index].is_received_boolean == "string"
          ? !JSON.parse(
              this.voucherBulkList[index].is_received_boolean.toLowerCase()
            )
          : !this.voucherBulkList[index].is_received_boolean;
      db.gvList.get({ gv_id: item.gv_id }, (voucher) => {
        if (voucher == undefined)
          this.addToDatabase(this.voucherBulkList[index]);
        else db.gvList.delete(voucher.id);
      });
      this.voucherGroupSelect();
    },
    async selectAllVoucher(e) {
      await this.voucherBulkList.forEach((item) => {
        item.is_received_boolean = e.target.checked;
        if (e.target.checked) {
          db.gvList.get({ gv_id: item.gv_id }, (voucher) => {
            if (voucher == undefined) this.addToDatabase(item);
          });
        } else
          db.gvList.get({ gv_id: item.gv_id }, (voucher) => {
            db.gvList.delete(voucher.id);
          });
      });
      this.voucherGroupSelect();
    },
    voucherGroupSelect: _.debounce(function() {
      let count = 0;
      this.voucherBulkList.forEach((item) => {
        if (
          typeof item.is_received_boolean == "boolean" &&
          item.is_received_boolean
        )
          count++;
      });
      if (count == this.voucherBulkList.length)
        document.getElementById("select-group").checked = true;
      else document.getElementById("select-group").checked = false;

      this.countSelectedVoucher();
    }, 200),
    async countSelectedVoucher() {
      let count = 0;
      db.transaction("rw", db.gvList, async () => {
        count = await db.gvList
          .where("gv_group_id")
          .equals(this.voucherDetails.groupInfo.gv_group_id)
          .count();
      }).then(async () => {
        this.updateBtnText =
          count == 0 ? "Update Cart" : `Update Cart ( ${count} )`;
        if (this.voucherDetails.groupInfo.value_type == "Fixed")
          this.disableUpdateBtn = count == 0 ? true : false;
        else if (this.voucherDetails.groupInfo.value_type == "Custom") {
          await db.gvList
            .where("gv_group_id")
            .equals(this.voucherDetails.groupInfo.gv_group_id)
            .and((filter) => {
              return (
                parseInt(filter.gift_value) != 0 &&
                filter.gift_value != null &&
                filter.gift_value != ""
              );
            })
            .count((c) => {
              if (count > 0 && count != 0)
                this.disableUpdateBtn = count == c ? false : true;
              else if (c == 0) this.disableUpdateBtn = true;
            });
        }
      });
    },
    updateCart(action_type) {
      this.$loading = true;
      let selected = [];
      db.transaction("rw", db.gvList, async () => {
        selected = await db.gvList
          .orderBy("id")
          .and((filter) => {
            return (
              filter.is_received_boolean &&
              filter.gv_group_id == this.voucherDetails.groupInfo.gv_group_id
            );
          })
          .toArray();
      }).then(() => {
        this.$store
          .dispatch("giftVoucher/cartActions", {
            action_type: action_type,
            gv_group_id: this.voucherDetails.groupInfo.gv_group_id,
            selected: selected,
          })
          .then(() => {
            if (action_type == "add_update") this.$refs["voucher-bulk"].hide();
            else this.$refs["voucher-detail"].hide();

            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message:
                action_type == "add_update"
                  ? msg.VOUCHER_ADDED
                  : msg.VOUCHER_GROUP_REMOVED,
              type: "success",
            });

            this.$loading = false;
          })
          .catch(() => (this.$loading = false));
      });
    },
    clearGvList() {
      this.pagination.page = 1;
      this.voucherBulkList = [];
    },
    addToDatabase(item) {
      db.gvList.add({
        is_received_boolean: true,
        gv_id: item.gv_id,
        gv_group_id: item.gv_group_id,
        sale_value: item.sale_value,
        gift_value: item.gift_value,
        gv_code: item.gv_code,
        voucher_sequence: item.voucher_sequence,
      });
    },
    addBulkQty() {
      if (
        this.bulkQty == "" ||
        this.voucherDetails.groupInfo.sale_value == "" ||
        this.voucherDetails.groupInfo.gift_value == ""
      )
        return;
      this.$loading = true;
      let data = {
        action_type: "bulk_add",
        gv_group_id: this.voucherDetails.groupInfo.gv_group_id,
        selected: [],
        bulk_qty: this.bulkQty,
        value_type: this.voucherDetails.groupInfo.value_type,
        sale_value: this.voucherDetails.groupInfo.sale_value,
        gift_value: this.voucherDetails.groupInfo.gift_value,
      };
      this.$store
        .dispatch("giftVoucher/cartActions", data)
        .then((res) => {
          this.$loading = false;
          let type = {
            message: "",
            type: "",
          };
          if (res.data.status == "success") {
            this.$refs["voucher-qty"].hide();
            type = {
              message: `${this.bulkQty} ${msg.VOUCHER_ADDED}`,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", type);
          }
        })
        .catch(() => (this.$loading = false));
    },
    updateGiftValue(item) {
      if (item.gift_value == "") {
        item.sale_value = null;
        db.gvList
          .get({ gv_id: item.gv_id }, (v) =>
            db.gvList.update(v.id, {
              sale_value: null,
              gift_value: null,
            })
          )
          .then(() => this.countSelectedVoucher());
      } else {
        this.$store
          .dispatch("giftVoucher/getSaleValue", {
            gv_group_id: item.gv_group_id,
            gift_value: item.gift_value,
            action_type: "cal_bulk",
          })
          .then((res) => {
            if (res != undefined && res.data.status == "success") {
              item.sale_value = res.data.data.sale_value;
              item.gift_value = res.data.data.gift_value;
              db.gvList
                .get({ gv_id: item.gv_id }, (v) =>
                  db.gvList.update(v.id, {
                    sale_value: res.data.data.sale_value,
                    gift_value: res.data.data.gift_value,
                  })
                )
                .then(() => this.countSelectedVoucher());
            }
          });
      }
    },
    getSaleValue() {
      this.$store
        .dispatch("giftVoucher/getSaleValue", {
          gv_group_id: this.voucherDetails.groupInfo.gv_group_id,
          gift_value: this.voucherDetails.groupInfo.gift_value,
          action_type: "cal_bulk",
        })
        .then((res) => {
          if (res != undefined)
            this.voucherDetails.groupInfo.sale_value = parseFloat(
              res.data.data.sale_value
            ).toFixed(2);
        });
    },
    giftDisp(item) {
      let temp = this.currencySymbol + item.gift_value;
      if (item.value_type == "Fixed")
        temp = this.currencySymbol + item.gift_value;
      else temp = "-";
      return temp;
    },
    saleDisp(item) {
      let temp = `<span>${this.currencySymbol + item.sale_value}</span>`;
      if (item.value_type == "Fixed")
        temp = `<span>${this.currencySymbol + item.sale_value}</span>`;
      else if (
        (typeof item.is_received_boolean == "boolean" &&
          item.is_received_boolean &&
          item.value_type == "Custom" &&
          item.gift_value == null) ||
        item.gift_value == "" ||
        parseInt(item.gift_value) == 0
      )
        temp = "<span class='grey-60'>Enter Sale Value to view</span>";
      else if (
        item.value_type == "Custom" &&
        item.gift_value != null &&
        item.gift_value != "" &&
        parseInt(item.gift_value) != 0
      ) {
        if (item.sale_value == null || item.sale_value == "")
          temp = `<span>${this.currencySymbol}0.00</span>`;
        else
          temp = `<span>${this.currencySymbol +
            parseFloat(item.sale_value).toFixed(2)}</span>`;
      } else temp = "<span>-</span>";
      return temp;
    },
    giftValueText(item) {
      return item.value_type == "Custom"
        ? "Custom"
        : `${this.currencySymbol}${item.gift_value}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.gvoucher-container {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 338px);
  @include custom-scrollbar();
  .gvoucher-list {
    border-bottom: 1px solid #e0e0e0;
  }
}
.sequence-code {
  padding-left: 10px;
}
.voucher-list {
  border-bottom: 1px solid $dark-card-title-header;
}
.negative-margin {
  margin: 0 -22px;
}
</style>
